import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=604e618a&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=ts"
export * from "./GlobalSearch.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=604e618a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e618a",
  null
  
)

export default component.exports